module.exports = __webpack_public_path__ + "static/media/Business-News.49c6b36a.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/Business-News.png
// module id = 359
// module chunks = 0